import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { MdOutlineNavigateNext } from 'react-icons/md';
import { GrFormPrevious } from 'react-icons/gr';
import AddEmployeeModal from '../components/AddEmployeeModal';
import EditEmployeeModal from '../components/EditEmployeeModal';
import DeleteModal from '../components/DeleteEmployeeModal';
import { useEmployeeData } from '../components/EmployeeContext';

const Employee = () => {
  const { employeeData, setEmployeeData } = useEmployeeData();
  const [employeeToEdit, setEmployeeToEdit] = useState(null);
  const [employeeToDelete, setEmployeeToDelete] = useState(null);
  const [modalType, setModalType] = useState('add');
  const [isAddEmployeeModalOpen, setAddEmployeeModalOpen] = useState(false);
  const [isEditEmployeeModalOpen, setEditEmployeeModalOpen] = useState(false);
  const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState('');
  const entriesPerPage = 9;
  const totalEntries = employeeData.length;
  const totalPages = Math.ceil(totalEntries / entriesPerPage);
  const startEntry = (currentPage - 1) * entriesPerPage + 1;
  const endEntry = Math.min(startEntry + entriesPerPage - 1, totalEntries);

  const openAddEmployeeModal = () => {
    setModalType('add');
    setAddEmployeeModalOpen(true);
  };
  const closeAddEmployeeModal = () => setAddEmployeeModalOpen(false);

  const openEditEmployeeModal = (employee) => {
    setModalType('edit');
    setEmployeeToEdit(employee);
    setEditEmployeeModalOpen(true);
  };
  const closeEditEmployeeModal = () => {
    setEmployeeToEdit(null);
    setEditEmployeeModalOpen(false);
  };

  const openDeleteModal = (employee) => {
    setModalType('delete');
    setEmployeeToDelete(employee);
    setDeleteModalOpen(true);
  };
  const closeDeleteModal = () => {
    setDeleteModalOpen(false);
    setEmployeeToDelete(null);
  };

  const handlePrevPage = () => setCurrentPage((prev) => Math.max(prev - 1, 1));
  const handleNextPage = () =>
    setCurrentPage((prev) => Math.min(prev + 1, totalPages));

  const removeEmployee = (email) => {
    setEmployeeData((prevEmployees) =>
      prevEmployees.filter((emp) => emp.email !== email)
    );
  };

  const filteredEmployees = employeeData.filter((employee) =>
    Object.values(employee)
      .join(' ')
      .toLowerCase()
      .includes(searchQuery.toLowerCase())
  );

  return (
    <div className='dashboard-container'>
      <div className='content'>
        {/* Table Section */}
        <div className='card'>
          <div className='d-flex justify-content-between align-items-center flex-wrap p-4'>
            <div className='d-flex flex-column flex-md-row align-items-md-center'>
              <input
                type='text'
                placeholder='Search'
                className='form-control flex-grow-1 me-md-3 mb-3 mb-md-0 border-0'
                style={{
                  maxWidth: '250px',
                  borderRadius: '30px',
                  background: '#f5f7fa',
                  color: '#969696',
                }}
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />

              <select
                className='form-select border-0 me-md-3 mb-3 mb-md-0'
                style={{
                  maxWidth: '170px',
                  borderRadius: '30px',
                  background: '#f5f7fa',
                  color: '#969696',
                }}
              >
                <option value='department'>Sort by: Dept.</option>
                <option value='name'>Sort by: Name</option>
              </select>
            </div>

            <div className='d-flex flex-column flex-md-row align-items-start align-items-md-center'>
              <Link
                to='#'
                className='btn mt-md-3 me-md-3 mb-3 mb-md-0'
                style={{
                  backgroundColor: '#ffff',
                  color: '#1f1f21',
                  textDecoration: 'none',
                  border: '1px solid #969696',
                  borderRadius: '10px',
                  fontWeight: '600',
                }}
              >
                Export CSV
              </Link>

              <Link
                to='#'
                className='btn mt-md-3'
                onClick={openAddEmployeeModal}
                style={{
                  backgroundColor: '#f37a20',
                  color: '#fff',
                  textDecoration: 'none',
                  borderRadius: '10px',
                }}
              >
                Add an Employee
              </Link>
              <AddEmployeeModal
                isOpen={isAddEmployeeModalOpen}
                onClose={closeAddEmployeeModal}
                setEmployees={setEmployeeData}
                type={modalType}
              />
            </div>
          </div>

          <div className='card-body'>
            {employeeData.length === 0 ? (
              <p>Loading employees...</p>
            ) : (
              <div className='table-responsive'>
                <table className='table'>
                  <thead>
                    <tr>
                      <th
                        style={{
                          borderBottom: '1px solid #e5e5e5',
                          color: '#969696',
                          fontSize: '14px',
                          fontWeight: '500',
                        }}
                      >
                        Name
                      </th>
                      <th
                        style={{
                          borderBottom: '1px solid #e5e5e5',
                          color: '#969696',
                          fontSize: '14px',
                          fontWeight: '500',
                        }}
                      >
                        Dept
                      </th>
                      <th
                        style={{
                          borderBottom: '1px solid #e5e5e5',
                          color: '#969696',
                          fontSize: '14px',
                          fontWeight: '500',
                        }}
                      >
                        Email
                      </th>
                      <th
                        style={{
                          borderBottom: '1px solid #e5e5e5',
                          color: '#969696',
                          fontSize: '14px',
                          fontWeight: '500',
                        }}
                      >
                        Contact
                      </th>
                      <th
                        style={{
                          borderBottom: '1px solid #e5e5e5',
                          color: '#969696',
                          fontSize: '14px',
                          fontWeight: '500',
                        }}
                      >
                        Rides
                      </th>
                      <th
                        style={{
                          borderBottom: '1px solid #e5e5e5',
                          color: '#969696',
                          fontSize: '14px',
                          fontWeight: '500',
                        }}
                      >
                        Expense
                      </th>
                      <th
                        style={{
                          borderBottom: '1px solid #e5e5e5',
                          color: '#969696',
                          fontSize: '14px',
                          fontWeight: '500',
                        }}
                      >
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredEmployees
                      .slice(startEntry - 1, endEntry)
                      .map((employee, index) => (
                        <tr
                          key={index}
                          style={{ borderBottom: '1px solid #e5e5e5' }}
                        >
                          <td
                            className='py-3'
                            style={{ fontSize: '14px', fontWeight: '500' }}
                          >
                            {employee.name}
                          </td>
                          <td
                            className='py-3'
                            style={{ fontSize: '14px', fontWeight: '500' }}
                          >
                            {employee.department}
                          </td>
                          <td
                            className='py-3'
                            style={{ fontSize: '14px', fontWeight: '500' }}
                          >
                            {employee.email}
                          </td>
                          <td
                            className='py-3'
                            style={{ fontSize: '14px', fontWeight: '500' }}
                          >
                            {employee.phone}
                          </td>
                          <td
                            className='py-3'
                            style={{ fontSize: '14px', fontWeight: '500' }}
                          >
                            {employee.ridesTaken}
                          </td>
                          <td
                            className='py-3'
                            style={{ fontSize: '14px', fontWeight: '500' }}
                          >
                            {employee.totalExpense}
                          </td>
                          <td
                            className='py-3'
                            style={{ fontSize: '14px', fontWeight: '500' }}
                          >
                            <Link
                              to='#'
                              className='btn me-md-3 mb-3 mb-md-0'
                              onClick={() => openDeleteModal(employee)}
                              style={{
                                background: '#c71e1e',
                                color: '#fff',
                                width: '90px',
                                height: '35px',
                                textDecoration: 'none',
                                borderRadius: '3.3px',
                              }}
                            >
                              Remove
                            </Link>
                            <DeleteModal
                              isOpen={isDeleteModalOpen}
                              onClose={closeDeleteModal}
                              employeeToDelete={employeeToDelete}
                              removeEmployee={removeEmployee}
                              setEmployees={setEmployeeData}
                              type={'delete'}
                            />
                            <Link
                              to='#'
                              onClick={() => openEditEmployeeModal(employee)}
                              className='btn'
                              style={{
                                border: '1px solid #969696',
                                width: '65px',
                                height: '35px',
                                textDecoration: 'none',
                                borderRadius: '3.3px',
                              }}
                            >
                              Edit
                            </Link>
                            <EditEmployeeModal
                              isOpen={isEditEmployeeModalOpen}
                              onClose={closeEditEmployeeModal}
                              employeeToEdit={employeeToEdit}
                              type={'edit'}
                            />
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>

          {/* Footer Section */}
          <div className='d-flex justify-content-between align-items-center flex-wrap p-4'>
            <div>
              <span style={{ color: '#969696' }}>
                Showing {startEntry}-{endEntry} of {totalEntries} entries
              </span>
            </div>
            {totalEntries > entriesPerPage && (
              <div>
                <button
                  className='btn btn-link me-2'
                  disabled={currentPage === 1}
                  onClick={handlePrevPage}
                >
                  <GrFormPrevious />
                </button>
                <button
                  className='btn btn-link'
                  disabled={currentPage === totalPages}
                  onClick={handleNextPage}
                >
                  <MdOutlineNavigateNext />
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Employee;
